import React from 'react';
import { styles } from './styles';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';

import { BenefitIcon } from './images';
import Section from '../../../shared/Section/Section';

function BenefitsStrip({ benefits }) {
  const isLg = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isGreaterSm = useMediaQuery((theme) => theme.breakpoints.up('sm'));

  return (
    <Section theme="light" customStyles={styles.section} withoutBg>
      <Box style={styles.strip(isLg, isGreaterSm)}>
        <Grid
          container
          spacing={isSm ? 1.5 : 3}
          justifyContent="space-between"
          alignItems="center"
        >
          {benefits &&
            benefits.map(({ text, type }) => (
              <Grid key={type} item sm={12} lg={3}>
                <Box style={styles.card(isSm)}>
                  <BenefitIcon type={type} isSm={isSm} />
                  <Typography
                    style={styles.text(isSm)}
                    variant={isSm ? 'mobileP2' : 'desktopP1'}
                    color={'kit.text.main'}
                  >
                    {text}
                  </Typography>
                </Box>
              </Grid>
            ))}
        </Grid>
      </Box>
    </Section>
  );
}

export default BenefitsStrip;
